module.exports = __webpack_public_path__ + "img/idea-vision-idea-icon.2782a660.svg";